(function() {
  function removeModalTriggers() {
    // 找到所有有 data-bs-toggle="modal" 的产品图片 <li>
    document.querySelectorAll('.gallery-wrapper [data-bs-toggle="modal"]').forEach(el => {
      el.removeAttribute('data-bs-toggle');
      el.removeAttribute('data-bs-target');
      el.classList.remove('cursor-pointer');
    });
    
    // 同时找 .js-product-gallery 里的
    document.querySelectorAll('.js-product-gallery [data-bs-toggle="modal"]').forEach(el => {
      el.removeAttribute('data-bs-toggle');
      el.removeAttribute('data-bs-target');
      el.classList.remove('cursor-pointer');
    });
  }
  
  function init() {
    removeModalTriggers();
    
    // 保险：监听 DOM 变化，画廊重新渲染时再移除一次
    const galleryEl = document.querySelector('.gallery-wrapper');
    if (galleryEl) {
      const observer = new MutationObserver(removeModalTriggers);
      observer.observe(galleryEl, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-bs-toggle']
      });
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.js-mj-buynow');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var form = btn.closest('form');
    if (!form) return;
    var original = btn.innerHTML;
    btn.dataset.mjLabel = original;
    btn.disabled = true;
    btn.innerHTML = 'Processing...';
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.json(); })
      .then(function(res) {
        if (res.status) { throw new Error(res.description || res.message || 'Unable to add to cart'); }
        window.location.href = '/checkout';
      })
      .catch(function(err) {
        btn.disabled = false;
        btn.innerHTML = original;
        var pf = form.closest('product-form');
        var wrap = pf ? pf.querySelector('.product-form__error-message-wrapper') : null;
        if (wrap) {
          wrap.removeAttribute('hidden');
          var msg = wrap.querySelector('.product-form__error-message');
          if (msg) msg.textContent = err.message || 'Something went wrong';
        } else { alert(err.message || 'Something went wrong'); }
      });
  });
})();

/* 0831: back/forward-cache restore — reset stuck Buy Now buttons (点击返回后一直Processing的修复) */
(function() {
  function resetBuyNow() {
    document.querySelectorAll('.js-mj-buynow').forEach(function(btn) {
      if (btn.disabled || (btn.innerHTML || '').indexOf('Processing') !== -1) {
        if (btn.dataset.mjLabel) btn.innerHTML = btn.dataset.mjLabel;
        else if ((btn.innerHTML || '').indexOf('Processing') !== -1) btn.innerHTML = 'Buy It Now';
        btn.disabled = false;
      }
    });
  }
  window.addEventListener('pageshow', resetBuyNow);
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible') resetBuyNow();
  });
})();
